import Grid from '@mui/material/Grid';

import JoinTheWaitlist from 'reservations/availabilities/components/JoinTheWaitlist';
import type { DinerFieldProps } from 'reservations/availabilities/types';
import AddToWaitlistButton from 'reservations/form/components/AddToWaitlistButton';
import { BaseDinerFields } from 'reservations/form/components/BaseDinerFields';

export const WaitlistFields = ({ handleFormDrawerClose }: DinerFieldProps) => (
  <>
    <Grid item>
      <JoinTheWaitlist />
    </Grid>
    <BaseDinerFields shouldAuthenticate={false} />
    <Grid item>
      <AddToWaitlistButton handleFormDrawerClose={handleFormDrawerClose} />
    </Grid>
  </>
);
